import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/bff/client';

import FilterGroup from '../filter-group';
import FormSlider from '../../../ui/form/form-slider';

const PriceSliderFilter = props => {
  const budget = props.budget || '';
  const splittedBudget = budget.split('-');
  const budgetMin = parseInt(splittedBudget[0], 10) || 0;
  const budgetMax = parseInt(splittedBudget[1], 10) || props.maxPriceInCity;

  return (
    <FilterGroup
      classModifier="price-range"
      label={trans('search.filter.price.range')}
    >
      <FormSlider
        histogramMaxHeight={30}
        name="budget"
        onChange={props.updateFiltersWith}
        sliderFrom={budgetMin}
        sliderTo={budgetMax}
        currency={props.currency}
        unitPrices={props.unitPrices}
        maxPrice={props.maxPriceInCity}
        trackingPrefix="ga-search-form-price-slider"
      />
    </FilterGroup>
  );
};

PriceSliderFilter.propTypes = {
  budget: PropTypes.object,
  updateFiltersWith: PropTypes.func.isRequired,
  currency: PropTypes.object.isRequired,
  unitPrices: PropTypes.array.isRequired,
  maxPriceInCity: PropTypes.number.isRequired
};

export default PriceSliderFilter;
